import Vue from 'vue';
import App from './App.vue';
import axios from "./helpers/axios";

import _ from 'lodash';
// Vuesax Component Framework
import Vuesax from 'vuesax';
import 'material-icons/iconfont/material-icons.css'; //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
import VueTheMask from 'vue-the-mask'

import VueTheMoney from 'v-money'
import VueNumberInput from '@chenfengyuan/vue-number-input';

Vue.use(Vuesax);

Vue.use(VueNumberInput);
Vue.use(VueTheMoney);
Vue.use(VueTheMask);
// Theme Configurations
import '../themeConfig.js';

// Globally Registered Components
import './globalComponents.js';

// Styles: SCSS
import './assets/scss/main.scss';

// Tailwind
import '@/assets/css/main.css';

// Vue Router
import router from './router';

// Vuex Store
import store from './store/store';

// PrismJS
import 'prismjs';
import 'prismjs/themes/prism.css';

// Feather font icon
require('./assets/css/iconfont.css');

// VeeValidate
import VeeValidate from 'vee-validate';

Vue.use(VeeValidate);

// Google Maps
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
    load: {
        // Add your API key here
        key: process.env.NODE_ENV === "development" ? 'AIzaSyCDTeZ0DtyRCJbQmaqgsXh8PLwwlKJjCzo' : 'AIzaSyBJs7xbU1Q2v_EalvZS_Pf7gDwX58M0tPY',
        libraries: 'places, geocoding', // This is required if you use the Auto complete plug-in
    },
});

// Tooltip
import Tooltip from 'vue-directive-tooltip';

import 'vue-directive-tooltip/dist/vueDirectiveTooltip.css';

Vue.use(Tooltip);

import 'vue2-daterange-picker/dist/lib/vue-daterange-picker.min.css'

Vue.config.productionTip = process.env.NODE_ENV === "development";

Object.defineProperty(Vue.prototype, '$axios', {value: axios});

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
